import { useMemo } from "react";
import fetch from "unfetch";
import useSWR, { ConfigInterface } from "swr";
import { TilannekuvaCacheKeys } from "./cacheKey";
import { IMaptilerTileset } from "../models/MaptilerTileset";

export type IUseMaptilerTilesetHook = (tilesetUrl: string, config?: ConfigInterface<any>) => {
    data: IMaptilerTileset | null;
    fetching: boolean;
}

export const useMaptilerTileset: IUseMaptilerTilesetHook = (tilesetUrl, config = {}) => {

    const mapresourceUrl = tilesetUrl.endsWith("/{z}/{x}/{y}.png") ? tilesetUrl.replace("/{z}/{x}/{y}.png", "") : tilesetUrl;

    const fetcher = async (): Promise<IMaptilerTileset | null> => {

        const response = await fetch(mapresourceUrl);

        const json = await response.json();
        if (json.success === false) {
            throw Error(json)
        }
        const tileset: IMaptilerTileset = {
            ...json,
            id: json.id,
            tileUrl: tilesetUrl,
            mapresource: json.metadata
        };

        return tileset;
    };

    const cacheKey = TilannekuvaCacheKeys.MaptilerTilesetInstance(mapresourceUrl);

    const { data, isValidating } = useSWR(
        cacheKey,
        fetcher,
        { suspense: true, ...config }
    );


    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating
    }), [rawData, isValidating]);
};
